<div class="mt-3 flex-align-items wrap logs-filters g-10">
  <button (click)="toggleNewFilter($event)" [disabled]="isLoading" id="add-filter" class="btn btn-sm btn-primary">
    <i class="icofont icofont-ui-add"></i><span>{{ 'AddFilter' | translate }}</span>
  </button>
  <button
    [title]="(hasFilterActive ? 'DisableAllFilters' : 'EnableAllFilters') | translate"
    (click)="hasFilterActive ? disableAllFilters() : enableAllFilters()"
    [disabled]="!filters.size || isLoading"
    class="disable-all btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center"
  >
    <i [ngClass]="hasFilterActive ? 'icon-filter-blocked' : 'icofont-filter'" class="icofont"></i>
  </button>
  <div *ngFor="let filterEntry of filters | keyvalue" class="filter">
    @let filter = filterEntry.value;
    <button
      (click)="openEditFilterMenu($event, filter)"
      class="btn btn-sm btn-outline-primary flex-align-items filter-btn"
      [ngStyle]="{ opacity: filter.active && !isLoading ? 1 : 0.5 }"
      [disabled]="isLoading"
    >
      <i *ngIf="!filter.active" class="icofont icon-filter-blocked"></i>
      <b>{{ filter.filterDefinition.slug | translateLabel }}</b>
      <ng-container [ngSwitch]="filter.filterDefinition.type">
        <ng-container *ngSwitchCase="FilterType.MULTI_IN_NOTIN">
          <i *ngIf="filter.data[LogFiltersType.IN]?.length" class="ml-1 icofont icofont-plus-circle"></i>
          <span
            *ngIf="filter.data[LogFiltersType.IN]?.length"
            [innerHTML]="formatValuesToPrint(filter.data[LogFiltersType.IN])"
          ></span>
          <i *ngIf="filter.data[LogFiltersType.NOTIN]?.length" class="ml-1 icofont icofont-minus-circle"></i>
          <span
            *ngIf="filter.data[LogFiltersType.NOTIN]?.length"
            [innerHTML]="formatValuesToPrint(filter.data[LogFiltersType.NOTIN])"
          ></span>
        </ng-container>
        <ng-container *ngSwitchCase="FilterType.SINGLE_INPUT">
          {{ filter.data }}&nbsp;{{ filter.filterDefinition.suffix }}
        </ng-container>
        <ng-container *ngSwitchCase="FilterType.SINGLE_SELECT">
          {{ formatValueToPrint(filter) }}&nbsp;{{ filter.filterDefinition.suffix }}
        </ng-container>
        <ng-container *ngSwitchCase="FilterType.INTERVAL">
          {{ filter.data[LogFiltersType.GTE] }} {{ 'and' | translate }} {{ filter.data[LogFiltersType.LTE] }}
          {{ filter.filterDefinition.suffix }}
        </ng-container>
      </ng-container>
      <div class="delete-filter">
        <i (click)="deleteFilter(filter, $event)" class="ml-1 icofont icofont-close"></i>
      </div>
    </button>
  </div>
</div>

<app-tooltip-menu #tooltipFilterMenu>
  <ul class="filter-menu">
    <li (click)="toggleEditFilter($event)">
      <i class="icofont icofont-edit-alt"></i>
      <span>{{ 'Edit' | translate }}</span>
    </li>
    <li
      *ngIf="currentFilter?.active && currentFilter.filterDefinition.type == FilterType.MULTI_IN_NOTIN"
      (click)="invertInNotInEvent(currentFilter, $event)"
    >
      <i class="icon-arrows-horizontal"></i>
      <span>{{ 'Invert' | translate }}</span>
    </li>
    <li *ngIf="currentFilter?.active" (click)="toggleActiveFilter(currentFilter, $event)">
      <i class="icofont icon-filter-blocked"></i>
      <span>{{ 'TemporarilyDisable' | translate }}</span>
    </li>
    <li *ngIf="!currentFilter?.active" (click)="toggleActiveFilter(currentFilter, $event)">
      <i class="icofont icofont-filter"></i>
      <span>{{ 'Reenable' | translate }}</span>
    </li>
    <li (click)="deleteFilter(currentFilter, $event)">
      <i class="icofont icofont-ui-delete"></i>
      <span>{{ 'supprimer' | translate }}</span>
    </li>
  </ul>
</app-tooltip-menu>

<app-tooltip-menu #tooltipNewFilter>
  <div class="new-filter">
    <h6>{{ (mode === Mode.ADD ? 'NewFilter' : 'EditFilter') | translate }}</h6>
    <div class="content">
      <div class="logs-new-filter" [style]="currentFilter ? '' : 'width: 100%'">
        <div class="form-group mb-0">
          <label for="">{{ 'FilterType' | translate }}</label>
          <ng-select
            [(ngModel)]="selectedFilter"
            [closeOnSelect]="true"
            [disabled]="mode === Mode.EDIT"
            (change)="onSelectedFilterChange()"
            bindValue="key"
            class="large-dropdown"
          >
            <ng-container *ngFor="let f of availableFilterDefinitions">
              <ng-option *ngIf="mode == Mode.EDIT || !filters.get(f.key)" [value]="f" style="padding: 2px 8px">
                {{ f.slug | translate }}
              </ng-option>
            </ng-container>
          </ng-select>
        </div>
      </div>
      <ng-container *ngIf="currentFilter" [ngSwitch]="currentFilter.filterDefinition.type">
        <div class="filter-edit">
          <ng-container *ngSwitchCase="FilterType.SINGLE_SELECT">
            <div class="form-group no-label">
              <ng-select
                class="custom-scrollbar no-arrow"
                [ngClass]="{ 'large-dropdown': currentFilter.filterDefinition.largeDropDown }"
                [(ngModel)]="currentFilter.data"
                [closeOnSelect]="true"
                [searchable]="false"
                [items]="currentFilter.filterDefinition.choices"
                bindLabel="slug"
                bindValue="value"
                [addTag]="currentFilter.filterDefinition.canAddChoice ? validateField : null"
                [multiple]="false"
                [clearable]="false"
              >
                <ng-template let-item="item" ng-option-tmp>
                  <span [innerHTML]="item.slug"></span>
                </ng-template>
              </ng-select>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="FilterType.MULTI_IN_NOTIN">
            <div class="form-group mb-0">
              <label for="">{{ 'ValuesToInclude' | translate }}</label>
              <ng-select
                class="custom-scrollbar no-arrow long-dropdown"
                [ngClass]="{ 'large-dropdown': currentFilter.filterDefinition.largeDropDown }"
                [(ngModel)]="currentFilter.data[LogFiltersType.IN]"
                [closeOnSelect]="false"
                [clearSearchOnAdd]="true"
                [searchFn]="customSearchFn"
                [notFoundText]="
                  currentFilter.filterDefinition.canAddChoice
                    ? translate.instant('AddValues')
                    : translate.instant('NoData')
                "
                [addTagText]="translate.instant('ajouter')"
                [searchable]="true"
                [items]="currentFilter.filterDefinition.visibleChoices ?? currentFilter.filterDefinition.choices"
                bindLabel="slug"
                [addTag]="currentFilter.filterDefinition.canAddChoice ? validateField : null"
                [multiple]="true"
                [clearable]="true"
                (paste)="handlePaste($event, currentFilter, LogFiltersType.IN)"
              >
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <span class="ng-value-icon left" (click)="clear(item)">×</span>
                  <span [innerHTML]="item.slug" [title]="item.slug" class="ng-value-label"></span>
                </ng-template>
                <ng-template let-item="item" ng-option-tmp>
                  <span [innerHTML]="item.slug"></span>
                </ng-template>
              </ng-select>
            </div>
            <button
              [title]="'Invert' | translate"
              (click)="invertInNotIn(currentFilter)"
              class="intervert btn btn-sm btn-outline-primary d-flex"
            >
              <i class="icon-arrows-horizontal"></i>
            </button>
            <div class="form-group mb-0">
              <label for="">{{ 'ValuesToExclude' | translate }}</label>
              <ng-select
                class="selector custom-scrollbar no-arrow long-dropdown"
                [ngClass]="{ 'large-dropdown': currentFilter.filterDefinition.largeDropDown }"
                [(ngModel)]="currentFilter.data[LogFiltersType.NOTIN]"
                [closeOnSelect]="false"
                [clearSearchOnAdd]="true"
                [notFoundText]="
                  currentFilter.filterDefinition.canAddChoice
                    ? translate.instant('AddValues')
                    : translate.instant('NoData')
                "
                [addTagText]="translate.instant('ajouter')"
                [searchable]="true"
                [searchFn]="customSearchFn"
                [items]="currentFilter.filterDefinition.visibleChoices ?? currentFilter.filterDefinition.choices"
                bindLabel="slug"
                [addTag]="currentFilter.filterDefinition.canAddChoice ? validateField : null"
                [multiple]="true"
                [clearable]="true"
                (paste)="handlePaste($event, currentFilter, LogFiltersType.NOTIN)"
              >
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <span class="ng-value-icon left" (click)="clear(item)">×</span>
                  <span [innerHTML]="item.slug" [title]="item.slug" class="ng-value-label"></span>
                </ng-template>
                <ng-template let-item="item" ng-option-tmp>
                  <span [innerHTML]="item.slug"></span>
                </ng-template>
              </ng-select>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="FilterType.SINGLE_INPUT">
            <div class="form-group">
              <label for="">{{ 'Values' | translate }}</label>
              <input
                [(ngModel)]="currentFilter.data"
                class="form-control [&::-webkit-inner-spin-button]:appearance-none"
              />
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="FilterType.INTERVAL">
            <div class="form-group">
              <label for="">{{ 'From...' | translate }}</label>
              <input
                [(ngModel)]="currentFilter.data[LogFiltersType.GTE]"
                class="form-control [&::-webkit-inner-spin-button]:appearance-none"
              />
            </div>
            <i class="no-label arrow-between icofont icofont-long-arrow-right"></i>
            <div class="form-group">
              <label for="">{{ 'to' | translate }}</label>
              <input
                [(ngModel)]="currentFilter.data[LogFiltersType.LTE]"
                class="form-control [&::-webkit-inner-spin-button]:appearance-none"
              />
            </div>
          </ng-container>
          <div *ngIf="currentFilter.filterDefinition.suffix" class="new-filter-suffix">
            {{ currentFilter.filterDefinition.suffix }}
          </div>
        </div>
      </ng-container>
    </div>
    <div *ngIf="currentFilter?.filterDefinition?.tooltip" class="new-filter-tooltip bg-blue">
      <small [innerHTML]="currentFilter?.filterDefinition?.tooltip | translate"></small>
    </div>
    <div class="buttons">
      <button (click)="cancelAddEditFilter($event)" class="btn btn-sm btn-outline-danger">
        {{ 'Annuler' | translate }}
      </button>
      <button
        (click)="mode === Mode.ADD ? addFilter($event) : editFilter($event)"
        [disabled]="!canAddEditFilter"
        class="btn btn-sm btn-primary"
      >
        {{ (mode === Mode.ADD ? 'Ajouter' : 'Validate') | translate }}
      </button>
    </div>
  </div>
</app-tooltip-menu>
